import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { BankLog } from "@/modules/finances/entity";
import FinanceLayout from "@/modules/finances/pages/FinanceLayout.vue";
import Logs from "@/modules/finances/components/Logs.vue";
import ItemsPaginator from "@/modules/vue/components/ItemsPaginator.vue";
import dayjs from "dayjs";
export default /*#__PURE__*/_defineComponent({
  __name: 'LogsMonthlyPage',
  async setup(__props) {
    let __temp, __restore;
    const allLogs = ref(([__temp, __restore] = _withAsyncContext(() => BankLog.createQueryBuilder('log').innerJoinAndSelect('log.season', 'season').andWhere('season.current = true').orderBy('log.createdAt').getMany()), __temp = await __temp, __restore(), __temp));
    const refDate = ref(dayjs.utc());
    const monthMapping = ref([7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6]);
    const logs = ref(collect(monthMapping.value).map(m => allLogs.value.filter(l => dayjs.utc(l.createdAt).month() === m - 1)).toArray());
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(FinanceLayout, null, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('bank')), 1)]),
        default: _withCtx(() => [_createVNode(ItemsPaginator, {
          ref: "paginator",
          "all-items": logs.value,
          "per-page": 1
        }, {
          display: _withCtx(({
            items,
            currentPage,
            perPage
          }) => [_createTextVNode(_toDisplayString(refDate.value.month(monthMapping.value[currentPage - 1] - 1).format('MMMM')), 1)]),
          default: _withCtx(({
            items,
            currentPage,
            perPage
          }) => [_createVNode(Logs, {
            logs: items[0]
          }, null, 8, ["logs"])]),
          _: 1
        }, 8, ["all-items"])]),
        _: 1
      });
    };
  }
});